import Environment from '../common/Environment';
import Member from '../entities/Member';
import Note from '../entities/Note';
import NoteJson from '../jsons/NoteJson';

export default class DeleteNote {
  execute(note: Note, account: Member): Promise<void> {
    const method: string = 'DELETE';
    const path = Environment.server() + '/note/' + note.id;

    return new Promise((resolve, reject) => {
      fetch(path, {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          account
        })
      })
        .then((response: Response) => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: NoteJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve();
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(
            `通信に失敗しました。ネットワークに問題がある可能性があります。\n${error.message}`
          );
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/DeleteNote.ts